export const selectSavedSearchInsightsPropertyIds = (state): { [key: string]: { addedAt: string } } | null => {
  return state.savedSearch.insightsPropertyIds;
};

export const selectSavedSearchCreatedAt = (state): string | null => {
  return state.savedSearch.createdAt;
};
